<template>
    <div class="userinfo">
        <Header :title="navtitle"></Header>
        <van-form @submit="onSubmit">
            <van-field name="avatar" :label="$t('userinfo.avatar')">
                <template #input>
                    <van-uploader v-model="avatar" :after-read="afterRead"  :before-read="beforeRead" :max-count="1"/>
                </template>
            </van-field>

            <van-field
                    v-model="username"
                    name="username"
                    :label="$t('userinfo.username')"
                    :placeholder="$t('userinfo.username')"
                    :rules="[{ required: true, message: $t('userinfo.user_tips') }]"
            />
            <van-field
                    v-model="mobile"
                    type="tel"
                    name="mobile"
                    :label="$t('login.phone')"
                    :placeholder="$t('login.phone')"
                    :rules="[{ required: true, message: $t('userinfo.mobile_tips') }]"
            />
            <van-field
                    v-model="name"
                    type="text"
                    name="name"
                    :label="$t('userinfo.name')"
                    :placeholder="$t('userinfo.rename')"
                    :rules="[{ required: true, message: $t('userinfo.name_tips')  }]"
            />
            <van-field
                    v-model="card"
                    type="text"
                    name="card"
                    :label="$t('userinfo.moneyAddr')"
                    :placeholder="$t('userinfo.moneyStr')"
                    :rules="[{ required: true, message: $t('userinfo.money_tips') }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="info" color="linear-gradient(to right, #ff6034, #ee0a24)" native-type="submit">{{ $t('userinfo.tj' )}}</van-button>
            </div>
        </van-form>
        <Footer></Footer>
    </div>

</template>

<script>
    import Header from '@/components/Header.vue'
    import Footer from '@/components/Footer.vue'
    import {getReq} from "../../utils/api";
    export default {
        name: "UserInfo",
        data(){
            return{
                navtitle :this.$t('userinfo.pagetitle'),
                username:'',
                mobile:'',
                name:'',
                card :'',
                avatar: [],

            }
        },
        mounted(){
            this.getUserinfo();
        },
        methods: {
            onSubmit(values) {
                if(values){
                    this.postReq('/updateinfo',values).then(res=>{
                        if(res){
                            if(res.code==200){
                                this.$toast(this.$t('forget.submitok'));
                            }else{
                                this.$toast(this.$t('userinfo.update_tips'));
                            }
                        }
                    })
                }
            },
            afterRead(file){
                if(file){
                    // 创建form对象
                    let formdata1 = new FormData();
                    // 通过append向form对象添加数据,可以通过append继续添加数据
                    //或formdata1.append('file',file);
                    formdata1.append('file', file.file, file.file.name);

                    this.instance.post(
                         "/upfile",
                        formdata1
                    ).then((res)=>{
                        console.log(res);
                       // this.avatar['url'] = res.data.data;
                        this.avatar = [{ url: res.data.data,isImage: true}];
                    });
                   // console.log(fileList)
                   // this.avatar = [{ url: res.data.content,isImage: true}];
                }

            },
            //将base64转换为文件
            // dataURLtoFile(dataurl) {
            //     var arr = dataurl.split(','),
            //         bstr = atob(arr[1]),
            //         n = bstr.length,
            //         u8arr = new Uint8Array(n)
            //     while (n--) {
            //         u8arr[n] = bstr.charCodeAt(n)
            //     }
            //     return new File([u8arr], this.files.name, {
            //         type: this.files.type
            //     })
            // },
            // 返回布尔值
            beforeRead(file) {
                if (file.type !== 'image/jpeg'&&file.type !== 'image/gif'&&file.type !== 'image/png') {
                    this.$toast(this.$t('userinfo.format_tips'));
                    return false;
                }
                if(file.size>1024*1024*3) {
                    this.$toast(this.$t('userinfo.size_tips'));
                    return false;
                }
                return true;
            },
            getUserinfo(){
                getReq('/getUserinfo').then((res)=>{
                    if(res.code==200){
                       this.username = res.data.username;
                        this.mobile = res.data.mobile;
                        this.name = res.data.name;
                        this.card = res.data.card;
                        this.avatar = [{ url: res.data.avatar }];
                    }
                })
            }

        },
        components:{
            Header,
            Footer
        }
    }
</script>

<style scoped lang="scss">
    .userinfo{
        min-height: 40rem;
    }
</style>
